import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    layout: css({
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    }),

    back: css({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: isHosTheme ? '22px' : '60px',
        color: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        cursor: 'pointer',
        textDecoration: isHosTheme ? 'underline' : 'none',
        ':hover': {
            textDecoration: 'underline',
        },
        [theme.breakpoints.down('lg')]: {
            textDecoration: 'underline',
            margin: '0 auto',
        },
    }),

    icon: css({
        marginRight: '10px',
        '.arrow-color': {
            fill: isHosTheme ? theme.palette.text.primary : theme.palette.customBlue,
        },
    }),

    wrapper: css({
        marginTop: '32px',
    }),

    padded: css({
        padding: '0px 20px',
        overflowWrap: 'anywhere',
    }),

    title: css({
        marginBottom: '20px',
    }),

    cta: css({
        borderRadius: '100px',
        paddingBlock: '16px',
        width: isHosTheme ? '256px' : '100%',
        marginTop: '30px',
    }),

    logoWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        padding: '0 20px',
        textAlign: 'center',
        gap: '20px',
        alignItems: 'center',
        margin: '30px 0 40px 0',
        justifyContent: 'center',
        alignSelf: 'stretch',
        ...(isHosTheme && {
            [theme.breakpoints.up('lg')]: {
                textAlign: 'left',
                padding: '10px 0',
                display: 'inline',
            },
        }),
    }),

    santanderLogo: css({
        width: '100px',
        height: '50px',
    }),

    mobileSummary: css({
        marginTop: '40px',
        display: 'flex',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    }),

    roomCardWrapper: css({
        width: '100%',
        ...(isHosTheme && {
            borderColor: theme.palette.secondary.dark,
            borderRadius: theme.custom.borderRadius[23],
            backgroundColor: theme.palette.common.white,
            marginBottom: '20px',
        }),
    }),

    bookingDetailsWrapper: css({
        borderTop: isHosTheme
            ? `1px solid ${theme.palette.primary.main}`
            : `1px solid ${theme.palette.grey[600]}`,
        paddingBlock: '20px',
        marginInline: '20px',
    }),

    wrapBox: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '20px',
        alignSelf: 'stretch',
        paddingTop: '20px',
    }),

    signTickEmailWrapper: css({
        display: 'flex',
        padding: '30px 0px',
        flexDirection: 'column',
        gap: '30px',
        alignSelf: 'stretch',
        background: isHosTheme
            ? `${theme.palette.common.white} !important`
            : `${theme.palette.background.paper} !important`,
    }),

    nextStepWrap: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        alignItems: 'center',
    }),

    extraPadding: css({
        padding: '20px 0',
    }),
    header: css({
        marginBottom: '10px',
    }),
    intro: css({
        margin: '20px 0 20px 0',
    }),

    listItem: css({
        marginTop: '20px',
    }),
    errorBox: css({
        display: 'flex',
        padding: '20px',
        alignItems: 'flex-end',
        gap: '10px',
        alignSelf: 'stretch',
        background: theme.palette.error.light,
        color: theme.palette.primary.main,
        marginTop: '20px',
    }),
    paymentOptionBannerWrapper: css({
        ...(isHosTheme && {
            marginTop: '10px',
        }),
    }),
};
